import { useT } from "@/i18n/I18nContext";
import { Globe } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useT();
  return (
    <div className="flex items-center rounded-full border border-border overflow-hidden text-xs font-semibold" data-testid="language-switcher">
      <Globe className="h-3.5 w-3.5 ml-2.5 text-muted-foreground" />
      {["fr", "en"].map((l) => (
        <button
          key={l}
          onClick={() => setLang(l)}
          data-testid={`lang-${l}`}
          className={`px-2.5 py-1.5 uppercase transition-colors ${
            lang === l ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
          }`}
        >
          {l}
        </button>
      ))}
    </div>
  );
};
